export const defaultTranslations = {
  routing_number: 'Routing No.',
  account_number: 'Account No.',
} as const;
